import { Icon } from "../../../../types/prodcatBaseTypes";
import styles from "./DescriptionIcons.module.scss";

type Props = {
  icons: Icon[];
};

export const DescriptionIcons = ({ icons }: Props) => {
  if (icons.length === 0) return null;

  return (
    <ul data-testid="description:icons" className={styles.icons}>
      {icons.map(({ text, iconUrl, linkUrl }) => (
        <li key={iconUrl} className={styles.icon}>
          {linkUrl ? (
            <a
              className={styles.link}
              data-testid="description:icons:link"
              href={linkUrl}
            >
              <IconDetails text={text} iconUrl={iconUrl} />
            </a>
          ) : (
            <IconDetails text={text} iconUrl={iconUrl} />
          )}
        </li>
      ))}
    </ul>
  );
};

function IconDetails({ text, iconUrl }: { text: string; iconUrl: string }) {
  return (
    <>
      <img
        className={styles.image}
        data-testid="description:icons:image"
        src={iconUrl}
        alt="an icon"
      />
      <span className={styles.text} data-testid="description:icons:text">
        {text}
      </span>
    </>
  );
}
